/**
 * 件数の単位（要件定義書 §2.1 / 実装設計書 §7）。
 *
 * **数値と単位は必ず組で表示する。** 画面ごとに「名」「件」「回」を直書きすると、
 * 同じ指標が画面によって違う単位で出る（MTG決定事項なので単位は仕様であり、デザインより優先する）。
 *
 * | 対象 | 単位 |
 * |---|---|
 * | メッセージ数 / やりとり数 / インフルエンサー人数 / リーチ数 | 名 |
 * | タスク数 / 投稿件数 / 保存数 | 件 |
 * | インプレッション数 | 回 |
 *
 * ⚠ 既存画面（`/analysis`・`/report`・やりとり一覧）への適用は P2-8 (#1547) が担当する。
 *   本ファイルの新規作成と export までが P2-1 (#1540) の範囲。
 *
 * ⚠ ディレクトリ名は `packages/utilty`（リポジトリ既存の綴り誤り）。
 *   パッケージ名は `@unit/utility` なので **import 文は `@unit/utility`** が正しい。
 */
export const CountUnit = {
  /** メッセージ数 */
  message: "名",
  /** やりとり数 */
  exchange: "名",
  /** インフルエンサー人数 */
  influencer: "名",
  /** タスク・やりとり件数 */
  task: "件",
  /** 投稿数 */
  post: "件",
  /** 保存数 */
  save: "件",
  /** インプレッション数 */
  impression: "回",
  /** リーチ数 */
  reach: "名",
} as const;

export type CountUnitKey = keyof typeof CountUnit;
export type CountUnitValue = (typeof CountUnit)[CountUnitKey];
